import { Component, Input, ModuleWithProviders, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ScoreReportComponent } from '../score-report/score-report.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-score',
  templateUrl: './score.component.html',
  styleUrls: [ './score.component.scss'],
  standalone: true,
  imports: [
    MatCardModule,
    NgCircleProgressModule, 
    TablerIconsModule,
    MatButtonModule
  ],
  providers: [
    (NgCircleProgressModule.forRoot({     
    }) as ModuleWithProviders<NgCircleProgressModule>).providers!,
  ],
})
export class ScoreComponent implements OnInit {
  @Input() score: number;
  chart: any = {};
    
  constructor(private dialog: MatDialog) {
    this.chart = {
      backgroundColor: "#FDB900",
      backgroundStrokeWidth: "0",
      backgroundPadding: "8",
      radius: "117",
      space: "-2",
      toFixed: "0",
      maxPercent: "100",
      units: "",
      title: "Rendimento",
      // unitsColor: "#483500",
      outerStrokeWidth: "12", // Spessore della linea
      outerStrokeColor: "#FFFFFF",
      innerStrokeColor: "#FFFFFF",
      // innerStrokeWidth: "38",
      titleColor: "#483500",
      titleFontSize: "18",
      subtitleColor: "#483500",
      subtitleFontSize: "20",
      animationDuration: "1400",
      showInnerStroke: false,
      responsive: false,
      lazy: true,
      showSubtitle: true,
    }    
  }

  ngOnInit(): void {
    this.getScore();
  }

  getScore() {    
    this.chart.percent = this.score;

    if (this.score <= 40) {
      this.chart.subtitle = 'sotto soglia';
      this.chart.backgroundColor = '#db4408';
      this.chart.titleColor = '#FFFFFF';
      this.chart.subtitleColor = '#FFFFFF';
    } else if (this.score > 40 && this.score <= 70) {
      this.chart.subtitle = 'medio';
      this.chart.backgroundColor = '#FDB900';
    } else if (this.score > 70) {
      this.chart.subtitle = 'ottimale';
      this.chart.backgroundColor = '#00b772';
    }
  }

  scoreDetails() {
    const dialogRef = this.dialog.open(ScoreReportComponent, {
      minWidth: '50%',
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        // After closing
      }
    });
  }
}